// Folders can sit inside folders, this many levels deep (Folder::MAX_LEVELS in the API).
export const MAX_FOLDER_LEVELS = 3

const byName = (a, b) =>
  a.name.localeCompare(b.name, undefined, {
    numeric: true,
    sensitivity: 'base',
  })

// The API's flat folder list as sidebar items in tree order: each folder is followed
// by the folders inside it, A to Z. A folder whose parent isn't in the list sits at the top.
export function buildFolderTree(list) {
  const ids = new Set(list.map((folder) => folder.id))
  const kids = {}
  list.forEach((folder) => {
    const parent = ids.has(folder.parent_id) ? folder.parent_id : null
    ;(kids[parent] = kids[parent] || []).push(folder)
  })

  const items = []
  const walk = (parent, depth, trail) => {
    ;(kids[parent] || []).sort(byName).forEach((folder) => {
      const path = trail.concat(folder.name)
      items.push({
        id: String(folder.id),
        label: folder.name,
        count: folder.files_count,
        color: folder.color || null,
        parentId: parent === null ? null : String(parent),
        depth,
        path: path.join(' / '),
        hasChildren: !!(kids[folder.id] || []).length,
      })
      walk(folder.id, depth + 1, path)
    })
  }
  walk(null, 0, [])
  return items
}

// Ids of a folder's parent, grandparent and so on, nearest first.
export function ancestorIds(items, id) {
  const byId = {}
  items.forEach((item) => {
    byId[item.id] = item
  })
  const chain = []
  let current = byId[id]
  while (current && current.parentId !== null && byId[current.parentId]) {
    chain.push(current.parentId)
    current = byId[current.parentId]
  }
  return chain
}

// The folders that can be the parent of `folder` (null = a new folder): not itself or
// anything inside it, and not so deep that it, or what is inside it, passes the limit.
export function parentChoices(items, folder) {
  const heightOf = (id) => {
    const inside = items.filter((item) => item.parentId === id)
    return (
      1 + (inside.length ? Math.max(...inside.map((i) => heightOf(i.id))) : 0)
    )
  }
  const below = folder ? heightOf(folder.id) : 1
  const blocked = folder
    ? new Set(
        items
          .filter(
            (item) =>
              item.id === folder.id ||
              ancestorIds(items, item.id).includes(folder.id),
          )
          .map((item) => item.id),
      )
    : new Set()
  return items.filter(
    (item) =>
      !blocked.has(item.id) && item.depth + 1 + below <= MAX_FOLDER_LEVELS,
  )
}
